import { LockSettingType } from "../constants/schema.js";
import { arrayHas } from "../utils/arrayHas.js";
import { Open } from "../constants/open.js";
import { ActionType } from "./modules/dictionary/actions.js";
import { ActionType as ActionType$1 } from "./modules/table-column/actions.js";
import { actions as actions$1 } from "./modules/table-column/atom.actions.js";
import { actions as actions$2 } from "./modules/dictionary/atom.actions.js";
import { ActionType as ActionType$2 } from "./modules/editor/actions.js";
import { ActionType as ActionType$3, CodeSettingLocks } from "./modules/settings/actions.js";
import { actions as actions$3 } from "./modules/settings/atom.actions.js";
import { actions as actions$4 } from "./modules/editor/atom.actions.js";
import { ActionType as ActionType$4 } from "./modules/index/actions.js";
import { actions as actions$5 } from "./modules/index/atom.actions.js";
import { ActionType as ActionType$5 } from "./modules/index-column/actions.js";
import { actions as actions$6 } from "./modules/index-column/atom.actions.js";
import { ActionType as ActionType$6 } from "./modules/memo/actions.js";
import { actions as actions$7 } from "./modules/memo/atom.actions.js";
import { ActionType as ActionType$7 } from "./modules/relationship/actions.js";
import { actions as actions$8 } from "./modules/relationship/atom.actions.js";
import { ActionType as ActionType$8 } from "./modules/table/actions.js";
import { actions as actions$9 } from "./modules/table/atom.actions.js";
import { ActionType as ActionType$9 } from "./modules/table-group/actions.js";
import { actions as actions$10 } from "./modules/table-group/atom.actions.js";
import { pushStreamHistoryMap, pushUndoHistoryMap } from "./history.actions.js";
import { actions$ } from "./modules/dictionary/generator.actions.js";
import { actions$ as actions$$1 } from "./modules/memo/generator.actions.js";
import { actions$ as actions$$2 } from "./modules/table/generator.actions.js";
import { actions$ as actions$$3 } from "./modules/table-column/generator.actions.js";
import { actions$ as actions$$4 } from "./modules/table-group/generator.actions.js";
import { actions$ as actions$$5 } from "./modules/editor/generator.actions.js";
import { actions$ as actions$$6 } from "./modules/index/generator.actions.js";
import { actions$ as actions$$7 } from "./modules/index-column/generator.actions.js";
import { actions$ as actions$$8 } from "./modules/relationship/generator.actions.js";
import { actions$ as actions$$9 } from "./modules/settings/generator.actions.js";
//#region src/engine/actions.ts
var actions = Object.freeze({
	...actions$4,
	...actions$$5,
	...actions$5,
	...actions$$6,
	...actions$6,
	...actions$$7,
	...actions$7,
	...actions$$1,
	...actions$8,
	...actions$$8,
	...actions$3,
	...actions$$9,
	...actions$9,
	...actions$$2,
	...actions$1,
	...actions$$3,
	...actions$10,
	...actions$$4,
	...actions$2,
	...actions$
});
var ChangeActionTypes = [
	"table.add",
	"table.move",
	"table.moveTo",
	"table.remove",
	"table.changeName",
	"table.changeComment",
	"table.changeColor",
	"table.changeGroup",
	"table.sort",
	"table.changeLogicalName",
	"table.changeNameDerived",
	"column.add",
	"column.remove",
	"column.changeName",
	"column.changeComment",
	"column.changeDataType",
	"column.changeDefault",
	"column.changeAutoIncrement",
	"column.changePrimaryKey",
	"column.changeUnique",
	"column.changeNotNull",
	"column.move",
	"column.changeLogicalName",
	"column.changeDomain",
	"column.changeNameDerived",
	"relationship.add",
	"relationship.remove",
	"relationship.changeType",
	"relationship.changeOnDelete",
	"relationship.changeOnUpdate",
	"relationship.changeColumns",
	"index.add",
	"index.remove",
	"index.changeName",
	"index.changeUnique",
	"indexColumn.add",
	"indexColumn.remove",
	"indexColumn.move",
	"indexColumn.changeOrderType",
	"memo.add",
	"memo.move",
	"memo.moveTo",
	"memo.remove",
	"memo.changeValue",
	"memo.changeColor",
	"memo.resize",
	"tableGroup.add",
	"tableGroup.move",
	"tableGroup.moveTo",
	"tableGroup.remove",
	"tableGroup.resize",
	"tableGroup.changeName",
	"tableGroup.changeColor",
	"dictionary.add",
	"dictionary.update",
	"dictionary.remove",
	"settings.changeDatabaseName",
	"settings.changeZoomLevel",
	"settings.streamZoomLevel",
	"settings.scrollTo",
	"settings.streamScrollTo",
	"settings.changeShow",
	"settings.changeDatabase",
	"settings.changeCanvasType",
	"settings.changeLanguage",
	"settings.changeTableNameCase",
	"settings.changeColumnNameCase",
	"settings.changeBracketType",
	"settings.changeRelationshipDataTypeSync",
	"settings.changeColumnOrder",
	"settings.changeMaxWidthComment",
	"settings.changeLockSettings",
	"settings.changeDDLScript",
	"settings.changeNameViewMode",
	"editor.loadJson",
	"editor.clear"
];
var ReplicaChangeActionTypes = [...ChangeActionTypes, "settings.changeIgnoreSaveSettings"];
var ReplicaActionTypes = [...ReplicaChangeActionTypes, "editor.mergeLWW"];
var hasReadonlyIgnore = arrayHas([
	"settings.changeZoomLevel",
	"settings.streamZoomLevel",
	"settings.scrollTo",
	"settings.streamScrollTo",
	"settings.changeDatabase",
	"settings.changeCanvasType",
	"settings.changeLanguage",
	"settings.changeTableNameCase",
	"settings.changeColumnNameCase",
	"settings.changeBracketType",
	"settings.changeNameViewMode"
]);
var ReadonlyIgnoreActionTypes = [...ChangeActionTypes.filter((type) => !hasReadonlyIgnore(type))];
var ScreenSettingActionTypes = [
	"settings.changeZoomLevel",
	"settings.streamZoomLevel",
	"settings.scrollTo",
	"settings.streamScrollTo",
	"settings.changeShow",
	"settings.changeDatabase",
	"settings.changeCanvasType",
	"settings.changeLanguage",
	"settings.changeTableNameCase",
	"settings.changeColumnNameCase",
	"settings.changeBracketType",
	"settings.changeNameViewMode"
];
var EditStateOpenActionTypes = [
	"editor.editTable",
	"editor.editMemo",
	"editor.editTableGroup",
	"editor.drawStartRelationship",
	"editor.drawStartAddRelationship"
];
var EDIT_OPEN_KEYS = [
	Open.mapColumns,
	Open.automaticTablePlacement,
	Open.timeTravel
];
var opensEditDialog = ({ type, payload }) => type === "editor.changeOpenMap" && EDIT_OPEN_KEYS.some((key) => payload?.[key] === true);
var ViewIgnoreActionTypes = [
	"table.add",
	"table.move",
	"table.moveTo",
	"table.remove",
	"table.changeName",
	"table.changeComment",
	"table.changeColor",
	"table.changeGroup",
	"table.sort",
	"table.changeLogicalName",
	"table.changeNameDerived",
	"column.add",
	"column.remove",
	"column.changeName",
	"column.changeComment",
	"column.changeDataType",
	"column.changeDefault",
	"column.changeAutoIncrement",
	"column.changePrimaryKey",
	"column.changeUnique",
	"column.changeNotNull",
	"column.move",
	"column.changeLogicalName",
	"column.changeDomain",
	"column.changeNameDerived",
	"relationship.add",
	"relationship.remove",
	"relationship.changeType",
	"relationship.changeOnDelete",
	"relationship.changeOnUpdate",
	"relationship.changeColumns",
	"index.add",
	"index.remove",
	"index.changeName",
	"index.changeUnique",
	"indexColumn.add",
	"indexColumn.remove",
	"indexColumn.move",
	"indexColumn.changeOrderType",
	"memo.add",
	"memo.move",
	"memo.moveTo",
	"memo.remove",
	"memo.changeValue",
	"memo.changeColor",
	"memo.resize",
	"tableGroup.add",
	"tableGroup.move",
	"tableGroup.moveTo",
	"tableGroup.remove",
	"tableGroup.resize",
	"tableGroup.changeName",
	"tableGroup.changeColor",
	"dictionary.add",
	"dictionary.update",
	"dictionary.remove",
	"settings.changeDatabaseName",
	"settings.changeShow",
	"settings.changeRelationshipDataTypeSync",
	"settings.changeColumnOrder",
	"settings.changeMaxWidthComment",
	"settings.changeLockSettings",
	"settings.changeDDLScript"
];
var CodeSettingLockActionTypes = {
	"settings.changeLanguage": CodeSettingLocks.language,
	"settings.changeTableNameCase": CodeSettingLocks.tableNameCase,
	"settings.changeColumnNameCase": CodeSettingLocks.columnNameCase,
	"settings.changeBracketType": CodeSettingLocks.bracketType
};
var LockSettingActionTypes = {
	"settings.changeZoomLevel": LockSettingType.viewport,
	"settings.streamZoomLevel": LockSettingType.viewport,
	"settings.scrollTo": LockSettingType.viewport,
	"settings.streamScrollTo": LockSettingType.viewport,
	"settings.changeCanvasType": LockSettingType.canvasType,
	...CodeSettingLockActionTypes,
	"settings.changeNameViewMode": LockSettingType.unlockNameViewMode
};
var SharedStreamActionTypes = [
	"editor.sharedMouseTracker",
	"editor.sharedFocusTracker",
	"editor.sharedSelectionTracker",
	"editor.sharedDragSelectTracker"
];
var SharedActionTypes = [
	...ChangeActionTypes,
	...SharedStreamActionTypes,
	"editor.getLWW",
	"editor.mergeLWW"
];
var ClockActionTypes = [
	...ChangeActionTypes,
	"editor.getLWW",
	"editor.mergeLWW"
];
var isClockActionType = arrayHas(ClockActionTypes);
var isOwnActionType = arrayHas([
	ActionType$2,
	ActionType$8,
	ActionType$1,
	ActionType$6,
	ActionType$7,
	ActionType$3,
	ActionType$4,
	ActionType$5,
	ActionType$9,
	ActionType
].flatMap((types) => Object.values(types)));
var movesClock = (type) => isClockActionType(type) || !isOwnActionType(type);
var batchVersion = (clock, actions) => actions.some(({ type }) => movesClock(type)) ? clock.getNextVersion() : clock.getVersion();
function mergeBatchVersions(clock, actions) {
	actions.forEach(({ type, version }) => {
		if (movesClock(type)) clock.merge(version);
	});
}
var SharedFollowingActionTypes = [
	"settings.changeZoomLevel",
	"settings.streamZoomLevel",
	"settings.scrollTo",
	"settings.streamScrollTo",
	"settings.changeCanvasType",
	"settings.changeNameViewMode"
];
var StreamRegroupMoveActionTypes = [
	"table.move",
	"memo.move",
	"tableGroup.move"
];
var StreamRegroupColorActionTypes = [
	"table.changeColor",
	"memo.changeColor",
	"tableGroup.changeColor"
];
var StreamRegroupScrollActionTypes = ["settings.streamZoomLevel", "settings.streamScrollTo"];
var StreamActionTypes = [...Object.keys(pushStreamHistoryMap)];
var HistoryActionTypes = [...Object.keys(pushUndoHistoryMap), ...StreamActionTypes];
//#endregion
export { ChangeActionTypes, ClockActionTypes, CodeSettingLockActionTypes, EDIT_OPEN_KEYS, EditStateOpenActionTypes, HistoryActionTypes, LockSettingActionTypes, ReadonlyIgnoreActionTypes, ReplicaActionTypes, ReplicaChangeActionTypes, ScreenSettingActionTypes, SharedActionTypes, SharedFollowingActionTypes, SharedStreamActionTypes, StreamActionTypes, StreamRegroupColorActionTypes, StreamRegroupMoveActionTypes, StreamRegroupScrollActionTypes, ViewIgnoreActionTypes, actions, batchVersion, mergeBatchVersions, movesClock, opensEditDialog };
